module.exports = __webpack_public_path__ + "static/media/create_newlist.2faf547f.gif";